import * as tslib_1 from "tslib";
import { sp } from "@pnp/sp";
import { ClientSvcQueryable, ObjectPathBatch, objectPath, staticMethod } from "@pnp/sp-clientsvc";
import { TermStore, TermStores } from "./termstores";
/**
 * The root taxonomy object
 */
var Session = /** @class */ (function (_super) {
    tslib_1.__extends(Session, _super);
    function Session(webUrl) {
        if (webUrl === void 0) { webUrl = ""; }
        var _this = _super.call(this, webUrl) || this;
        // everything starts with the session
        _this._objectPaths.add(staticMethod("GetTaxonomySession", "{981cbc68-9edc-4f8d-872f-71146fcbb84f}", 
        // actions
        objectPath()));
        return _this;
    }
    Object.defineProperty(Session.prototype, "termStores", {
        /**
         * The collection of term stores
         */
        get: function () {
            return new TermStores(this);
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Provides access to sp.setup from @pnp/sp
     *
     * @param config Configuration
     */
    Session.prototype.setup = function (config) {
        sp.setup(config);
    };
    /**
     * Creates a new batch
     */
    Session.prototype.createBatch = function () {
        return new ObjectPathBatch(this.toUrl());
    };
    /**
     * Gets the default keyword termstore for this session
     */
    Session.prototype.getDefaultKeywordTermStore = function () {
        return this.getChild(TermStore, "GetDefaultKeywordsTermStore", null);
    };
    /**
     * Gets the default site collection termstore for this session
     */
    Session.prototype.getDefaultSiteCollectionTermStore = function () {
        return this.getChild(TermStore, "GetDefaultSiteCollectionTermStore", null);
    };
    return Session;
}(ClientSvcQueryable));
export { Session };
//# sourceMappingURL=session.js.map